import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getTvNews as getTvNewsApi,
  getTvNewsStats as getTvNewsStatsApi,
  planTvNews as planTvNewsApi,
  stopTvNews as stopTvNewsApi,
  deleteTvNews as deleteTvNewsApi,
} from "../../helpers/realbackend_helper";

export const getTvNews = createAsyncThunk(
  "tvnews/getTvNews",
  async (params, { rejectWithValue }) => {
    try {
      return await getTvNewsApi(params || {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTvNewsStats = createAsyncThunk(
  "tvnews/getTvNewsStats",
  async (_, { rejectWithValue }) => {
    try {
      return await getTvNewsStatsApi();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const planTvNews = createAsyncThunk(
  "tvnews/planTvNews",
  async (days, { rejectWithValue }) => {
    try {
      const r = await planTvNewsApi(days || 2);
      toast.success(
        `Төлөвлөгөө үүслээ: ${r.planned} шинэ, ${r.existing} байсан, ${r.skipped} алгассан`,
        { autoClose: 4000 }
      );
      return r;
    } catch (error) {
      toast.error("Төлөвлөгөө үүсгэхэд алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);

export const stopTvNews = createAsyncThunk(
  "tvnews/stopTvNews",
  async (id, { rejectWithValue }) => {
    try {
      const r = await stopTvNewsApi(id);
      toast.info("Бичлэгийг зогсоолоо", { autoClose: 3000 });
      return { id, ...r };
    } catch (error) {
      toast.error("Зогсооход алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);

export const deleteTvNews = createAsyncThunk(
  "tvnews/deleteTvNews",
  async (id, { rejectWithValue }) => {
    try {
      const r = await deleteTvNewsApi(id);
      toast.success("Бичлэгийг устгалаа", { autoClose: 3000 });
      return { id, ...r };
    } catch (error) {
      toast.error("Устгахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);
